/**
 * Maps league names to their corresponding sport types
 * Used to determine which sport icon to display in dropdowns
 */

export const SPORT_TYPES = {
  FOOTBALL: 'football',
  BASKETBALL: 'basketball',
  BASEBALL: 'baseball',
  SOCCER: 'soccer',
  HOCKEY: 'hockey',
  TENNIS: 'tennis',
  GOLF: 'golf',
  HORSE_RACING: 'horseracing',
};

/**
 * Get the sport type for a given league name
 * @param {string} leagueName - The name of the league
 * @returns {string|null} - The sport type or null if not a sport league
 */
export const getLeagueSport = (leagueName) => {
  if (!leagueName) return null;

  const league = leagueName.toUpperCase().trim();

  // Non-sport options (no icons)
  if (
    league === "TODAY'S EVENTS" ||
    league === 'UPCOMING EVENTS' ||
    league === 'TODAYS EVENTS' ||
    league === 'FAVORITES'
  ) {
    return null;
  }

  // Football leagues
  if (league === 'NFL' || league === 'NCAAF' || league === 'CFL') {
    return SPORT_TYPES.FOOTBALL;
  }

  // Basketball leagues
  if (
    league === 'NBA' ||
    league === 'WNBA' ||
    league === 'NCAAM' ||
    league === 'NCAAW' ||
    league.includes('NCAA BASKETBALL') ||
    league.includes('NCAA MEN') ||
    league.includes('NCAA WOMEN')
  ) {
    return SPORT_TYPES.BASKETBALL;
  }

  // Baseball leagues
  if (
    league === 'MLB' ||
    league === 'NCAA BASEBALL' ||
    league === 'NCAAB' ||
    league.includes('BASEBALL')
  ) {
    return SPORT_TYPES.BASEBALL;
  }

  // Soccer leagues
  if (
    league === 'MLS' ||
    league === 'EPL' ||
    league === 'LALIGA' ||
    league === 'LA LIGA' ||
    league === 'SERIE A' ||
    league === 'BUNDESLIGA' ||
    league === 'LIGUE 1' ||
    league === 'CHAMPIONS LEAGUE' ||
    league === 'UEFA' ||
    league === 'PREMIER LEAGUE' ||
    league.includes('SOCCER') ||
    league.includes('WORLD CUP') ||
    (league.includes('FOOTBALL') && !league.includes('NFL'))
  ) {
    return SPORT_TYPES.SOCCER;
  }

  // Hockey leagues
  if (
    league === 'NHL' ||
    league === 'NCAA HOCKEY' ||
    league.includes('HOCKEY')
  ) {
    return SPORT_TYPES.HOCKEY;
  }

  // Tennis
  if (
    league === 'ATP' ||
    league === 'WTA' ||
    league === 'TENNIS' ||
    league.includes('TENNIS')
  ) {
    return SPORT_TYPES.TENNIS;
  }

  // Golf
  if (
    league === 'PGA' ||
    league === 'LPGA' ||
    league === 'GOLF' ||
    league.includes('GOLF')
  ) {
    return SPORT_TYPES.GOLF;
  }

  // Horse Racing
  if (
    league === 'HORSE RACING' ||
    league.includes('HORSE RACING') ||
    league.includes('HORSERACING')
  ) {
    return SPORT_TYPES.HORSE_RACING;
  }

  // Default: no icon for unknown leagues
  return null;
};
